import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { RcsCreateStore } from 'pages/settings/pages/rcs/store/RcsCreateStore'

const RcsCreateContext = createContext<RcsCreateStore | null>(null)

export const useRcsCreateContext = () => {
  const context = useContext(RcsCreateContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with RcsCreateProvider')

  return context
}

export const RcsCreateProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new RcsCreateStore(entities), [])

  useEffect(() => store.dispose, [])

  return <RcsCreateContext.Provider value={store}>{children}</RcsCreateContext.Provider>
}
